export default "__VITE_ASSET__C8uJpz82__"